module.exports = __webpack_public_path__ + "img/mini-026.f9c8828c.jpg";